import { Camera } from "lucide-react";
import { toast } from "sonner";
import { apiFile, useAuth, usePhotoUpload } from "@/auth";

export default function Avatar({ testPrefix = "avatar", sizeCls = "h-16 w-16 text-xl" }) {
  const { user } = useAuth();
  const upload = usePhotoUpload();
  const initials = (user?.name || "?")
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  const onPick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      await upload(file);
      toast.success("Foto de perfil actualizada");
    } catch {
      toast.error("No se pudo subir la imagen. Prueba con otra en JPG, PNG o WebP.");
    }
    e.target.value = "";
  };

  return (
    <label className={`relative block shrink-0 cursor-pointer ${sizeCls}`} data-testid={`${testPrefix}-avatar`}>
      {user?.photo_url ? (
        <img
          src={apiFile(user.photo_url)}
          alt="Foto de perfil"
          className={`rounded-full border-2 border-accent object-cover shadow-[0_0_18px_rgba(255,0,122,0.3)] ${sizeCls}`}
        />
      ) : (
        <span className={`flex items-center justify-center rounded-full border-2 border-dashed border-accent/50 bg-accent/10 font-display font-extrabold text-accent ${sizeCls}`}>
          {initials}
        </span>
      )}
      <span className="absolute -bottom-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full bg-accent text-white shadow-lg transition-transform duration-300 hover:scale-110">
        <Camera size={13} />
      </span>
      <input type="file" accept="image/png,image/jpeg,image/webp" className="hidden" data-testid={`${testPrefix}-avatar-input`} onChange={onPick} />
    </label>
  );
}
